<template>
  <div>
    <div class="px-3">
      <h4 class="text-center font-weight-bold">개인정보 수집 및 이용 동의서</h4>
    </div>
    <div class="row justify-content-center">
      <p align="center">
        SK핀크스(주)는 홈페이지를 통하여 적법하고 공정한 수단에 의하여 고객님의 개인정보를 수집합니다.
      </p>
    </div>
    <table class="table table-borderless">
      <thead align="center">
        <tr style="border-top: 2px solid; border-bottom: 1px solid #cfcfcf; background-color: #f3f3f3">
          <th style="width: 40%; border-right: 1px solid #cfcfcf">필수항목</th>
          <th style="width: 40%; border-right: 1px solid #cfcfcf">수집 및 이용목적</th>
          <th style="width: 20%">보유기간</th>
        </tr>
      </thead>
      <tbody align="center">
        <tr style="border-bottom: 1px solid">
          <td style="border-right: 1px solid #cfcfcf; vertical-align: middle">
            <div>성명, 생년월일, 연락처, 이메일, 아이디, 비밀번호, 예약내역</div>
          </td>
          <td style="border-right: 1px solid #cfcfcf; vertical-align: middle">
            <ul class="text-left">
              <li>회원제 서비스에 따른 본인 확인 절차</li>
              <li>멤버십 혜택, 약관변경, 고지사항 전달</li>
              <li>문의/상담 및 불만 등에 대한 민원처리</li>
            </ul>
          </td>
          <td style="vertical-align: middle">
            <div class="text-emphasis">멤버십 가입기간 및 탈퇴 후 1년</div>
          </td>
        </tr>
      </tbody>
    </table>
    <p class="px-2">
      필수 항목에 대한 수집 및 이용에 동의 하지 않을 권리는 있으나, 미동의 시 서비스를 이용하실 수 없습니다.
    </p>
  </div>
</template>

<script>
export default {
  name: 'MemberPrivacy',
};
</script>

<style scoped lang="scss">
.table {
  th,
  td {
    font-size: 0.9rem;
    vertical-align: middle;
  }
}
ul {
  margin: 0rem;
  padding-left: 1.5rem;
}
p {
  //font-size: 0.9rem;
}
.text-emphasis {
  font-size: medium;
  font-weight: bold;
}
</style>
